import { render, staticRenderFns } from "./CMSSidebarContent.vue?vue&type=template&id=501a513a&"
import script from "./CMSSidebarContent.vue?vue&type=script&lang=js&"
export * from "./CMSSidebarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports